module.exports = __webpack_public_path__ + "static/img/iso_logo.8f54c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iso_logo.png
// module id = P8sA
// module chunks = 0